import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import DailyLoansView from "./DailyLoansView";
import {ReportsService} from "../../../service/reports/ReportsService";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {dateFormatterReportTable} from "../../../utils/formatters/Date";
import {rateDataTableTemplate} from "../../../utils/formatters/Numbers";
import {INTERNO_STR} from "../../../utils/constants/Constants";

export default class DailyLoansContainer extends Component {
    constructor(props) {
        super(props);

        this.reportsService = new ReportsService();
        this.getDataDailyReport = this.getDataDailyReport.bind(this);
        this.exportDocument = this.exportDocument.bind(this);
        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        let columns = [
            {field: "folioOperacion", header: "Folio", style: {textAlign: 'right', width: '100px'}},
            {field: "fechaConcertacion", header: "Fecha Concert", body: dateFormatterReportTable},
            {field: "fechaValor", header: "Fecha Valor", body: dateFormatterReportTable},
            {field: "horaConcertacion", header: "Hora Concertación"},
            {field: "fechaVencimiento", header: "Fecha Vencimiento", body: dateFormatterReportTable},
            {field: "plazoOperacion", header: "Plazo", style: {textAlign: 'right', width: '50px'}},
            {field: "instPTM", header: "PTM"},
            {field: "cuentaPTM", header: "Cuenta PTM"},
            {field: "instPTT", header: "PTT"},
            {field: "emisora", header: "Emisora"},
            {field: "tipoValor", header: "Clave"},
            {field: "serie", header: "Serie"},
            {field: "cupon", header: "Cupón"},
            {field: "cantidadTitulos", header: "Títulos", style: {textAlign: 'right', width: '100px'}},
            {field: "monedaOperacion", header: "Moneda"},
            {field: "precioPactado", header: "Precio", style: {textAlign: 'right', width: '100px'}},
            {field: "sobretasa", header: "Sobretasa", style: {textAlign: 'right', width: '70px'}},
            {field: "importe", header: "Importe", style: {textAlign: 'right', width: '100px'}},
            {field: "tasa", header: "Tasa", style: {textAlign: 'right', width: '60px'}},
            {field: "premio", header: "Premio", style: {textAlign: 'right', width: '100px'}},
            {field: "status", header: "Estatus", style: {textAlign: 'left', width: '60px'}},
        ];

        this.comisionCols = [
            {
                field: "comisionPtm",
                header: "Comisión PTM",
                style: {textAlign: 'right', width: '100px'},
                body: this.printValueLender
            },
            {
                field: "ivaPtm",
                header: "IVA PTM",
                style: {textAlign: 'right', width: '100px'},
                body: this.printValueLender
            },
            {
                field: "netoPtm",
                header: "Neto PTM",
                style: {textAlign: 'right', width: '100px'},
                body: this.printValueLender
            },
            {
                field: "comisionPtt",
                header: "Comisión PTT",
                style: {textAlign: 'right', width: '100px'},
                body: this.printValueBorrower
            },
            {
                field: "ivaPtt",
                header: "IVA PTT",
                style: {textAlign: 'right', width: '100px'},
                body: this.printValueBorrower
            },
            {
                field: "netoPtt",
                header: "Neto PTT",
                style: {textAlign: 'right', width: '100px'},
                body: this.printValueBorrower
            },
        ];

        this.state = {
            isLoading: false,
            cols: columns,
            columnSelected: {
                accountColumn: false,
                commissionColumn: false
            },
            filters: {
                guaranteeCheck: true,
                dateCheck: false,
            },
            dataDailyReport: [],
            exportOptions: [
                {
                    label: "Excel", action: () => {
                        this.openConfirmationMessage("Excel")
                    }
                },
                {
                    label: "PDF", action: () => {
                        this.openConfirmationMessage("PDF")
                    }
                },
                {
                    label: "CSV", action: () => {
                        this.openConfirmationMessage("CSV")
                    }
                },
            ],
            typeDocument: '',
            disabledSearchButton: false,
        };

        this.onColumnToggle = this.onColumnToggle.bind(this);
        this.onFiltersChange = this.onFiltersChange.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.loading = this.loading.bind(this);
    }

    printValueLender(rowData, column) {
        let institution = localStorage.getItem('institution');
        let returnValue = '';
        if (institution === INTERNO_STR || institution === rowData['instPTM']){
            returnValue = rowData[column.field];
        }
        return returnValue;
    }

    printValueBorrower(rowData, column) {
        let institution = localStorage.getItem('institution');
        let returnValue = '';
        if (institution === INTERNO_STR || institution === rowData['instPTT']){
            returnValue =  rowData[column.field];
        }
        return returnValue;
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    clearFilters() {
        let colsAux = JSON.parse(JSON.stringify(this.state.cols));
        this.state.cols.forEach((item)=>{
            if(item.field === "cuentaIndeval"){
                colsAux.splice(1, 1);
            }else if(item.field === "comisionPtm"){
                colsAux.splice(colsAux.length - 6, 6);
            }
        });

        this.setState({
            cols: colsAux,
            columnSelected: {
                accountColumn: false,
                commissionColumn: false
            },
            filters: {
                guaranteeCheck: true,
                dateCheck: false,
            },
        });
    }

    onColumnToggle(event) {
        let colsAux = this.state.cols;
        let columnSelectedAux = this.state.columnSelected;

        switch (event.target.name) {
            case "accountColumn":
                event.checked ?
                    colsAux.splice(1, 0,
                        {field: "cuentaIndeval", header: "Cuenta Indeval"}) :
                    colsAux.splice(1, 1);
                break;
            case "commissionColumn":
                event.checked ?
                    colsAux = colsAux.concat(this.comisionCols) :
                    colsAux.splice(colsAux.length - 6, 6);
                break;
            default:
                break;
        }
        columnSelectedAux[event.target.name] = event.checked;
        this.setState({
            cols: colsAux,
            columnSelected: columnSelectedAux,
        });
    }

    onFiltersChange(event) {
        let filtersAux = this.state.filters;
        filtersAux[event.target.name] = event.checked;

        this.setState({
            filters: filtersAux,
        });
    }

    rowExpansionTemplate(data) {
        const guaranteesItems = data.guaranteesList;
        return (
            <div className="p-grid">
                <div className="p-col-1"/>
                <div className="p-col-11">
                    <DataTable
                        tableClassName={"guarantees-column-header"}
                        value={guaranteesItems}
                        responsive={true}
                        resizableColumns={true}
                        columnResizeMode={"fit"}>
                        <Column field="date" header="Fecha" style={{textAlign: 'left'}} body={dateFormatterReportTable}
                                sortable={true}/>
                        <Column field="source" header="Origen" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="type" header="Tipo" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="coin" header="Moneda" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="emisora" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="clave" header="Clave" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="serie" header="Serie" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="cupon" header="Cupón" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="cuentaPTT" header="Cuenta PTT" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="titles" header="Títulos" style={{textAlign: 'right'}} sortable={true}/>
                        <Column field="price" header="Precio" style={{textAlign: 'right'}} sortable={true}/>
                        <Column field="guaranteeAmount" header="Imp. Garantizado" style={{textAlign: 'right'}}
                                sortable={true}/>
                        <Column field="guaranteeTotal" header="Tot. Garantizado" style={{textAlign: 'right'}}
                                sortable={true}/>
                        <Column field="guaranteePercentage" header="% Garantizado" style={{textAlign: 'right'}}
                                body={rateDataTableTemplate} sortable={true}/>
                    </DataTable>
                </div>
            </div>

        );
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    getDataDailyReport() {
        this.loading(true);
        this.setState({disabledSearchButton: true,});
        this.reportsService.getDailyReport(this.state.filters)
            .then(resp => {
                let expandedRowsAux = [];
                if (resp.error !== '') {
                    this.growl.show({
                        severity: 'info', summary: 'Atención.',
                        detail: resp.error
                    });
                } else {
                    if (this.state.filters.guaranteeCheck) {
                        resp.payload.map((row) => {
                            return (row.guaranteesList.length === 0 ? '' : expandedRowsAux.push(row));
                        });
                    }
                }
                this.setState({
                    dataDailyReport: resp.payload,
                    expandedRows: expandedRowsAux,
                    disabledSearchButton: false,
                });
                this.loading(false);
            });
    }

    exportDocument() {
        this.loading(true);
        if (this.state.dataDailyReport.length === 0) {
            this.growl.show({
                severity: 'info', summary: 'Atención.',
                detail: 'No existen datos'
            });
            this.loading(false);
        } else {
            let params = {
                bandera: this.state.columnSelected.commissionColumn ? 1 : 0,
                tipoReporte: 3,
                fecValor: this.state.filters.dateCheck ? 1 : 0,
                cuenta: this.state.columnSelected.accountColumn,
                chkGarantia: this.state.filters.guaranteeCheck,
            };

            switch (this.state.typeDocument) {
                case "Excel":
                    this.reportsService.getHistoricalReportXLS(params)
                        .then(res => {
                            this.getDataDailyReport();
                            this.loading(false);
                        });
                    break;
                case "PDF":
                    this.reportsService.getHistoricalReportPDF(params)
                        .then(res => {
                            this.getDataDailyReport();
                            this.loading(false);
                        });
                    break;
                case "CSV":
                    params = {
                        accion: 18012,//accion en servlet
                        band: this.state.filters.guaranteeCheck,//con garantias
                        bandera: false,//con comision
                        bandIsin: false,
                        bandCuenta: false,
                        par: 1,//tipo de reporte
                    };

                    this.reportsService.getHistoricalReportCSV(params)
                        .then(res => {
                            this.getDataDailyReport();
                            this.loading(false);
                        });
                    break;
                default:
                    break;
            }
        }
    }

    render() {
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Usted está seguro de continuar descargando la información solicitada?"
                                           action={this.exportDocument}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            dataDailyReport, isLoading, columnSelected, expandedRows,
            filters, exportOptions, disabledSearchButton
        } = this.state;
        let columns = this.state.cols.map((col, i) => {
            return <Column field={col.field}
                           header={col.header}
                           style={col.style ? col.style : {textAlign: 'left', width: '100px'}}
                           body={col.body ? col.body : ''}
                           sortable={true}
            />;
        });

        return <DailyLoansView
            dataDailyReport={dataDailyReport}
            isLoading={isLoading}
            messagesGrowl={messagesGrowl}
            columns={columns}
            filters={filters}
            columnSelected={columnSelected}
            expandedRows={expandedRows}
            exportOptions={exportOptions}
            confMsg={confMsg}
            disabledSearchButton={disabledSearchButton}
            onColumnToggle={this.onColumnToggle}
            onFiltersChange={this.onFiltersChange}
            rowExpansionTemplate={this.rowExpansionTemplate}
            getDataDailyReport={this.getDataDailyReport}
            clearFilters={this.clearFilters}
        />
    }
};